import { useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { compose } from 'ramda'
import get from 'lodash/get'

import withLayout from '~/hoc/withLayout'

import RegulationView from './RegulationView'

const GET_REGULATION = gql`
  query document (
    $id: ID!
  ) {
    document (
      id: $id
    ) {
      id
      title
      richText
    }
  }
`

const RegulationGql = ({ router }) => {
  const { id } = router.query

  const { data } = useQuery(GET_REGULATION, {
    variables: { id },
    skip: !id
  })

  return (
    <RegulationView
      regulation={get(data, 'document')}
    />
  )
}

export default compose(
  withLayout({
    contentClassName: 'regulation',
    withHeader: true,
    namespaces: ['regulations'],
  }),
)(RegulationGql)
